import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

const FormWrapperStyle = ({ theme }) => ({
  padding: '40px 0 100px 0',
  [theme.breakpoints.up('md')]: {
    padding: '60px 0 100px 0'
  }
});

export const DialogContentStyled = styled(DialogContent)(FormWrapperStyle);
